module.exports = __webpack_public_path__ + "img/icon-prev.6bcb9f8f.svg";